import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'frontend-live',
  templateUrl: './live.component.html',
  styleUrls: ['./live.component.scss'],
})
export class LiveComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
